<script lang="ts">
	import { page } from '$app/stores';
	import { acceptReferral } from '$lib/apis/referral';
	import {
		addErrorNotification,
		addTransactionSuccessfulNotification
	} from '$lib/notifications/notificationManager';
	import { popupModalOpen, popupModalType } from '$lib/popups/popupsStore';
	import ProcessingIcon from '$lib/util/ProcessingIcon.svelte';
	import { walletAddress, walletConnected } from '$lib/wallet/store';
	import { openWeb3Modal } from '$lib/wallet/wallet';
	import { signMessage } from '@wagmi/core';

	const closeModal = () => {
		popupModalOpen.set(false);
	};

	$: referralCode = $page.url.searchParams.get('referral') || '';

	let loading = false;

	const handleAcceptReferralClick = async () => {
		try {
			loading = true;

			const signatureString = `Adding a referral using referral code ${referralCode}`;
			const signature = await signMessage({
				message: signatureString
			});

			await acceptReferral($walletAddress, referralCode, signature);
			addTransactionSuccessfulNotification(
				'Referral Accepted',
				`You have been invited to use Polynomial Trade using the referral code ${referralCode}`
			);
		} catch (err: any) {
			console.log(err);
			addErrorNotification('Failed to accept referral!', err.message, '');
		} finally {
			popupModalOpen.set(false);
			loading = false;
		}
	};
</script>

<div
	class="flex flex-col items-center justify-start w-full sm:max-w-[400px] gap-4 bg-fx-gradient-8 p-4 rounded-xl border border-[#2F374A]"
>
	<div class="flex w-full items-center justify-between">
		<div class="flex items-end gap-1">
			<img src="/referral/title.svg" alt="title.svg" class="h-6 w-6 -mb-0.5" />
			<p class="text-fx-gradient-5 text-base font-bold">Welcome to Polynomial</p>
		</div>
		<button on:click={closeModal}>
			<img src="/scwallet/cross-small.svg" class="h-6 w-6" alt="zap" loading="lazy" />
		</button>
	</div>
	<div class="w-full h-px rounded-lg bg-fx-gradient-shine-3" />
	<p class="text-sm text-fx-grey-200">
		Trade decentralized perps with upto 50x leverage and deep liquidity on Polynomial.
	</p>
	<div
		class="bg-fx-gradient-6 flex w-full flex-col items-center justify-center gap-2 rounded-xl p-4"
	>
		<img src="/referral/art.png" alt="art.png" class="w-[90%]" loading="lazy" />
		<p class="text-fx-gradient-1 text-base font-bold">
			You’ve been invited using the code: {referralCode}
		</p>
		<div class="w-full h-px rounded-lg bg-fx-gradient-shine-3" />
		<div class="flex w-full items-center justify-center gap-1">
			<img src="/referral/check.svg" alt="check.svg" class="h-4 w-4" loading="lazy" />
		</div>
	</div>
	<div
		class="w-full p-3 flex justify-center items-center accept-referral-button cursor-pointer rounded bg-fx-gradient-1"
		on:click={() => (!$walletConnected ? openWeb3Modal() : handleAcceptReferralClick())}
		role="presentation"
	>
		{#if loading}
			<ProcessingIcon />
		{:else}
			<p class="text-fx-grey-900 text-sm font-semibold cursor-pointer">
				{!$walletConnected ? 'Connect Wallet' : 'Accept Referral'}
			</p>
		{/if}
	</div>
</div>

<style>
	.accept-referral-button {
		box-shadow: 0.5px 0.5px 0px 0px rgba(205, 205, 205, 0.7) inset,
			6px 6px 20px 0px rgba(205, 205, 205, 0.2) inset,
			-0.5px -0.5px 0px 0px rgba(205, 205, 205, 0.2) inset;
	}

	.bg-fx-gradient-shine-3 {
		background: linear-gradient(
			270deg,
			rgba(38, 38, 38, 0.5) 0%,
			rgba(169, 169, 169, 0.5) 48.44%,
			rgba(38, 38, 38, 0.5) 100%
		);
	}
</style>
